import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginationPipe} from './pagination/pagination.pipe';
import { ProfilePicturePipe } from './profilePicture/profilePicture.pipe';
import { ChatPersonSearchPipe } from './search/chat-person-search.pipe';
import { UserSearchPipe } from './search/user-search.pipe';
import { TruncatePipe } from './truncate/truncate.pipe';
import { MailSearchPipe } from './search/mail-search.pipe';
import { EmployeeSearchPipe } from './search/employee-search.pipe';
import { ProjectSearchPipe } from './search/project-search.pipe';
import { EmployeeSearch2Pipe } from './search/employee-search2.pipe';
import { SafeUrlPipe } from './safeUrl/safeUrl.pipe';
import { DaysOpenPipe } from './days-open/days-open.pipe';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        PaginationPipe,
        ProfilePicturePipe,
        ChatPersonSearchPipe,
        UserSearchPipe,
        TruncatePipe,
        MailSearchPipe,
        EmployeeSearchPipe,
        ProjectSearchPipe,
        EmployeeSearch2Pipe,
        SafeUrlPipe,
        DaysOpenPipe
    ],
    exports: [
        PaginationPipe,
        ProfilePicturePipe,
        ChatPersonSearchPipe,
        UserSearchPipe,
        TruncatePipe,
        MailSearchPipe,
        EmployeeSearchPipe,
        ProjectSearchPipe,
        EmployeeSearch2Pipe,
        SafeUrlPipe,
        DaysOpenPipe
    ]
})
export class PipesModule { }
